"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSerializableType = void 0;
var any_1 = require("../types/any");
var array_1 = require("../types/array");
var boolean_1 = require("../types/boolean");
var enums_1 = require("../types/enums");
var iterable_1 = require("../types/iterable");
var literal_1 = require("../types/literal");
var never_1 = require("../types/never");
var nullable_1 = require("../types/nullable");
var number_1 = require("../types/number");
var object_1 = require("../types/object");
var optional_1 = require("../types/optional");
var record_1 = require("../types/record");
var string_1 = require("../types/string");
var tuple_1 = require("../types/tuple");
var union_1 = require("../types/union");
var unknown_1 = require("../types/unknown");
var lambda_1 = require("./lambda");
function extractSerializableType(valueOrGuard) {
    if (typeof valueOrGuard === 'undefined') {
        return {
            type: 'undefined'
        };
    }
    if (typeof valueOrGuard === 'boolean' || typeof valueOrGuard === 'number' || typeof valueOrGuard === 'string') {
        return {
            type: 'literal',
            constant: valueOrGuard
        };
    }
    if (valueOrGuard instanceof any_1.AnyGuard) {
        return {
            type: 'any'
        };
    }
    if (valueOrGuard instanceof array_1.ArrayGuard) {
        return {
            type: 'array',
            items: extractSerializableType(valueOrGuard.options.items)
        };
    }
    if (valueOrGuard instanceof boolean_1.BooleanGuard) {
        return {
            type: 'boolean'
        };
    }
    if (valueOrGuard instanceof enums_1.EnumsGuard) {
        return {
            type: 'union',
            types: valueOrGuard.constants.map(extractSerializableType)
        };
    }
    if (valueOrGuard instanceof iterable_1.IterableGuard) {
        return {
            type: 'iterable',
            items: extractSerializableType(valueOrGuard.items)
        };
    }
    if (valueOrGuard instanceof literal_1.LiteralGuard) {
        return extractSerializableType(valueOrGuard.constant);
    }
    if (valueOrGuard instanceof never_1.NeverGuard) {
        return {
            type: 'never'
        };
    }
    if (valueOrGuard instanceof nullable_1.NullableGuard) {
        return {
            type: 'union',
            types: [
                {
                    type: 'null'
                },
                {
                    type: 'undefined'
                },
                extractSerializableType(valueOrGuard.guard)
            ]
        };
    }
    if (valueOrGuard instanceof number_1.NumberGuard) {
        return {
            type: 'number'
        };
    }
    if (valueOrGuard instanceof object_1.ObjectGuard) {
        return {
            type: 'object',
            props: Object.fromEntries((0, lambda_1.extractEntries)(valueOrGuard.options.props).map(function (_a) {
                var _b = __read(_a, 2), key = _b[0], valueOrGuard = _b[1];
                return [
                    key,
                    extractSerializableType(valueOrGuard)
                ];
            }))
        };
    }
    if (valueOrGuard instanceof optional_1.OptionalGuard) {
        return {
            type: 'union',
            types: [{ type: 'undefined' }, extractSerializableType(valueOrGuard.guard)]
        };
    }
    if (valueOrGuard instanceof record_1.RecordGuard) {
        return {
            type: 'record',
            key: extractSerializableType(valueOrGuard.key),
            value: extractSerializableType(valueOrGuard.value)
        };
    }
    if (valueOrGuard instanceof string_1.StringGuard) {
        return {
            type: 'string'
        };
    }
    if (valueOrGuard instanceof tuple_1.TupleGuard) {
        return {
            type: 'tuple',
            items: valueOrGuard.items.map(extractSerializableType)
        };
    }
    if (valueOrGuard instanceof union_1.UnionGuard) {
        return {
            type: 'union',
            types: valueOrGuard.guards.map(extractSerializableType)
        };
    }
    if (valueOrGuard instanceof unknown_1.UnknownGuard) {
        return {
            type: 'unknown'
        };
    }
    throw new TypeError("Unsupported value or guard: " + valueOrGuard);
}
exports.extractSerializableType = extractSerializableType;
